export const DEBOUNCE_TIMER = 700
export const INTEREST_RATE = '15.60'
export const RECAPTCHA_TOKEN = '2c17b72cc7f79e2e243c1fb6356ffd3c0eb3fdfff409b57f04c0735bde30f65c'
